import { render } from "./CollegeEntry.vue?vue&type=template&id=07da62f4&scoped=true"
import script from "./CollegeEntry.vue?vue&type=script&lang=ts"
export * from "./CollegeEntry.vue?vue&type=script&lang=ts"

import "./CollegeEntry.vue?vue&type=style&index=0&id=07da62f4&lang=less&scoped=true"
script.render = render
script.__scopeId = "data-v-07da62f4"

export default script